import queryKeys from '@/constants/queryKeys';
import { toggleMultipleNotificationsReadStatus } from '@/services/api/requests/notifications';
import { useMutation } from '@tanstack/react-query';

const useReadMultipleNotifications = (onSuccess: () => void) => {
  const { mutate, data, isError, error } = useMutation({
    mutationKey: [queryKeys.notifications.toggleReadMultiple],
    mutationFn: async (notificationIds: string[]) => {
      const response = await toggleMultipleNotificationsReadStatus(notificationIds);

      return response;
    },
    onSuccess,
  });

  return { mutate, data, isError, error };
};

export default useReadMultipleNotifications;
